<template>
  <div>
    <el-dialog
      :visible="visible"
      @close="$emit('update:visible', false)"
      @closed="clear"
    >
      <div
        slot="title"
        class="Diatitle"
      >
        <span>设备续费</span>
      </div>
      <div class="box">
        <div v-if="!batch">车牌: {{data&&data.plate || "暂无数据"}}</div>
        <div v-if="!batch">到期时间: {{data&&data.expireDate || "暂无数据"}}</div>
        <div v-if="batch">续费车辆数: {{count}}</div>
        <div>续费时长:
          <ul class="btnbox">
            <li
              :class="{select:selectIndex === index}"
              class="btn"
              v-for="(item, index) in btns"
              :key="index"
              @click="renewal(item)"
            >{{item.title}}</li>
          </ul>
        </div>
        <div v-if="!batch">
          续费后到期时间: {{newRenewalDay}}
        </div>
        <div class="coin">
          消耗<span>{{coin * count}}</span>个加设备币
        </div>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="$emit('update:visible', false)"
          size="small"
        >取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="renewalok"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import day from "dayjs";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    auto: {
      type: Boolean,
      default: false
    },
    data: {}
  },
  data() {
    return {
      coins: "",
      newRenewalDay: null,
      month: 1,
      coin: 1,
      selectIndex: 0,
      btns: [
        { title: "1月", value: 0, month: 1 },
        { title: "2月", value: 1, month: 2 },
        { title: "3月", value: 2, month: 3 },
        { title: "4月", value: 3, month: 4 },
        { title: "1年", value: 4, month: 12 },
        { title: "2年", value: 5, month: 24 },
        { title: "3年", value: 6, month: 36 },
        { title: "4年", value: 7, month: 48 }
      ],
      gvids: "",
      batch: false,
      count: 1
    };
  },
  watch: {
    data: {
      handler(val) {
        //判断是否是自定义续费
        if (this.auto) {
          this.batch = true;
          this.gvids = val && val[0].data.join(",");
          this.count = val && val[0].count;
        } else {
          //判断是否是批量续费
          if (val && val.length) {
            this.batch = true;
            var arr = [];
            val &&
              val.map(item => {
                arr.push(item.organizationId + "," + item.vehicleId);
              });
            this.gvids = arr.join(";");
            this.count = val.length;
          } else {
            this.batch = false;
            this.newRenewalDay = this.setData(1);
            this.gvids = [
              this.data && this.data.organizationId,
              this.data && this.data.vehicleId
            ].join(",");
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setData(month) {
      if (!this.data || !this.data.expireDate) {
        return day(day(new Date()).add(month, "month")).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      return day(new Date()).isBefore(day(this.data.expireDate))
        ? day(day(this.data.expireDate).add(month, "month")).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : day(day(new Date()).add(month, "month")).format(
            "YYYY-MM-DD HH:mm:ss"
          );
    },
    clear() {
      this.selectIndex = 0;
      this.coin = 1;
      this.month = 1;
      this.newRenewalDay = this.setData(1);
      this.count = 1;
      this.batch = false;
      this.$emit("update:data", null);
      this.$emit("update:auto", false);
    },
    //批量
    async vehicleRecharge() {
      try {
        const { msg } = await this.$API.vehicleRecharge({
          addMonth: this.month,
          gvids: this.gvids
        });
        this.$emit("update:visible", false);
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
      } catch (error) {
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    },
    //自定义
    async batchRecharge() {
      try {
        const { msg } = await this.$API.batchRecharge({
          addMonth: this.month,
          terminalNo: this.gvids
        });
        this.$emit("update:visible", false);
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
      } catch (error) {
        console.log(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    },
    async renewalok() {
      if (this.auto) {
        await this.batchRecharge();
        this.$emit("updateok");
        return;
      }
      await this.vehicleRecharge();
      this.$emit("updateok");
    },
    async renewal(item) {
      let val = item.value;
      this.month = item.month;
      this.selectIndex = val;
      this.newRenewalDay = this.setData(this.month);
      if (val < 5) {
        this.coin = val + 1;
      } else {
        this.coin = (val - 3) * 5;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 500px !important;
}
.box {
  .btnbox {
    display: flex;
    margin-left: 5px;
    .btn {
      height: 20px;
      width: 40px;
      background: rgb(187, 187, 187);
      line-height: 20px;
      text-align: center;
      margin-right: 1px;
      color: #fff;
      cursor: pointer;
      &:hover {
        background: rgb(0, 225, 255);
      }
    }
  }
  & div {
    height: 20px;
    display: flex;
    align-items: center;
    padding: 8px 0;
  }
  .coin {
    font-size: 24px;
    font-weight: bold;
    span {
      color: red;
    }
  }
}
.select {
  background: rgb(0, 225, 255) !important;
}
</style>